import { ricsAndCompanyBranchLabels } from '../constants/branch-labels';
import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const founderPreviousCompanyDefinition: FilterDefinition<TreeFilter> = {
  id: FilterId.FOUNDER_COMPANY,
  name: 'Founder Previous Company',
  selections: [],
  type: FilterType.TREE,
  selectionListIds: ['rics_k10', 'rics_k400', 'company'],
  branches: ricsAndCompanyBranchLabels,
  isVisible: true,
};

export const founderPreviousCompanyHandler: FilterHandler<TreeFilter> = {
  isActive(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: TreeFilter): TreeFilter {
    return currentFilterState;
  },
  getRequiredSelectionListIds(definition: FilterDefinition<TreeFilter>) {
    return definition.selectionListIds;
  },
};
